import type {ContextType} from '@packages/systems/wfdl';

export const getCommerceDataProperty = (
  propNameOrPath: string | string[],
  notFoundValue: any = undefined
) => {
  const path =
    typeof propNameOrPath === 'string' ? [propNameOrPath] : propNameOrPath;
  return (commercePluginContext: ContextType) => {
    const contextData = commercePluginContext.get('data', {});
    return get(contextData, path, notFoundValue);
  };
};

const get = (obj: any, path: string[], notFoundValue: any) => {
  let value = obj;
  let index = 0;

  while (index < path.length && value != null) {
    const prop = path[index];
    // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
    value = value[prop];
    index += 1;
  }

  if (index < path.length) {
    // while loop encountered nullish value before reaching end of path
    return notFoundValue;
  }

  return value === undefined ? notFoundValue : value;
};
